"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Abbr = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var VisualAccessible_1 = require("../../../shared/core/components/VisualAccessible");
var StyledAbbr = styled_components_1.default.abbr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var Abbr = function (_a) {
    var children = _a.children, ariaLabel = _a.ariaLabel;
    return (react_1.default.createElement(VisualAccessible_1.VisualAccessible, { accessibleLabel: ariaLabel },
        react_1.default.createElement(StyledAbbr, { title: ariaLabel }, children)));
};
exports.Abbr = Abbr;
var templateObject_1;
